import { complianceNotificationAnalyticsPorts } from '@/models/analytics/features/trackComplianceNotificationAnalytics';
import { PinnedComplianceNotificationCard } from '@heidi/growth';

import { VList } from 'virtua';
import NotificationCard from './notification-card';
import type { NotificationListItem } from './notification-list-items';
import { useOpenComplianceSettings } from './use-open-compliance-settings';

export const NotificationsList = ({ items }: { items: NotificationListItem[] }) => {
  const openComplianceSettings = useOpenComplianceSettings();

  return (
    // VList *is* the scroll container — so `pb-*` here only shows when
    // scrolled to the end, pairing with the popover's `pb-0` to let
    // mid-scroll rows bleed to the popover edge.
    <VList count={items.length} className="pb-1.5">
      {(i) => {
        // Key on the row's own identity so reorders / refetches (a new
        // inmail arriving mid-popover) reconcile to the correct card
        // instance — keying on `i` would let per-card state (open kebab,
        // hover) latch onto whatever row now sits at that index.
        const item = items[i];
        // VList's row renderer must return an element, never null.
        if (!item) return <></>;
        if (item.kind === 'compliance') {
          return (
            <PinnedComplianceNotificationCard
              key={item.key}
              notification={item.notification}
              onOpenSettings={openComplianceSettings}
              {...complianceNotificationAnalyticsPorts}
            />
          );
        }
        return <NotificationCard index={item.inmailIndex} key={item.key} />;
      }}
    </VList>
  );
};
